import { RPCs } from "../../../../services/rpc.js";
import { useRPC } from "../../../../hooks/useRPC/index.js";
// src/modules/SystemInfo/shared/hooks/useSystemInfoForTarget.ts
function useSystemInfoForTarget(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.System.GetSystemInfoForTarget.v1, args, {
		...opts,
		fire: (opts.fire ?? true) && !!args && !!args.target
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
export { useSystemInfoForTarget };

//# sourceMappingURL=useSystemInfoForTarget.js.map